import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c89c7b10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag_link" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "length" }


import { CameratagWithCameras } from '@/@types/typescript-axios/api'

type PropsType = {
  tag: CameratagWithCameras
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagLinkButton',
  props: {
    tag: null
  },
  emits: ['click'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click')), ["stop"])),
      class: "link_text"
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.tag.tag_name), 1),
      _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(__props.tag.cameras.length) + ")", 1)
    ])
  ]))
}
}

})